import { isEqual } from "lodash";
import moment from "moment";
import Check from "pages/_components/Check";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import { checkDisableMultiple, getBillActions } from "pages/creditBills/utils/actionMaker";
import InfoTag from "pages/echeck/components/InfoTag";
import { bool, func, instanceOf, shape, string } from "prop-types";
import React, { memo } from "react";
import { useDispatch } from "react-redux";
import { getBoolOption, monedas, statusTagColor } from "util/creditBills";

const CreditBillItem = memo(({ billItem, onSelectRow, selectedBills, isDesktop, tabOption }) => {
    const dispatch = useDispatch();
    const { isEmitted, isInTenure, isToPay, isReceived } = getBoolOption(tabOption);
    const isDisabled = checkDisableMultiple(billItem, tabOption);
    const billActionOptions = getBillActions(tabOption, billItem, dispatch).map((item) => ({
        text: item.label,
        func: item.onClick,
        textType: "I18N",
    }));
    const isExpired = moment(billItem.fechaVencimientoPago)
        .add("days", 1)
        .isSameOrBefore(moment());

    return (
        <>
            <GridTable.Data columnStart={1} rowStart={1} rowWidth={1} className={isDesktop && "debtor-class"}>
                <div
                    role="button"
                    tabIndex={0}
                    onClick={(e) => {
                        e.preventDefault();
                        onSelectRow(billItem);
                    }}
                    onKeyDown={(e) => {
                        e.preventDefault();
                        onSelectRow(billItem);
                    }}>
                    <Check
                        hideLabel
                        key={billItem.facturaId.numeroComprobante}
                        name={billItem.facturaId.numeroComprobante}
                        id={billItem.facturaId.numeroComprobante}
                        disabled={isDisabled}
                        checked={selectedBills.some((element) => isEqual(element.facturaId, billItem.facturaId))}
                    />
                </div>
            </GridTable.Data>

            {isEmitted && (
                <>
                    <GridTable.Data
                        className={isDesktop && "debtor-class"}
                        columnStart={2}
                        rowStart={1}
                        rowWidth={1}
                        alignX={isDesktop ? "center" : "flex-start"}>
                        <CustomData
                            titleText="creditBill.table.debtor"
                            titleTextType="I18N"
                            valueText={`${billItem.cuitComprador} ${billItem.razonSocialComprador}`}
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 2}
                        rowStart={isDesktop ? 1 : 2}
                        rowWidth={1}
                        alignX={isDesktop ? "center" : "flex-start"}>
                        <CustomData
                            titleText="creditBill.table.holder"
                            titleTextType="I18N"
                            valueText={`${billItem.cuitTenedor} ${billItem.razonSocialTenedor}`}
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>
                </>
            )}
            {isReceived && (
                <>
                    <GridTable.Data
                        className={isDesktop && "debtor-class"}
                        columnStart={2}
                        rowStart={1}
                        rowWidth={1}
                        alignX={isDesktop ? "center" : "flex-start"}>
                        <CustomData
                            titleText="creditBill.table.emitter"
                            titleTextType="I18N"
                            valueText={`${billItem.facturaId.cuitEmisor} ${billItem.razonSocialEmisor}`}
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 2}
                        rowStart={isDesktop ? 1 : 2}
                        rowWidth={1}
                        alignX={isDesktop ? "center" : "flex-start"}>
                        <CustomData
                            titleText="creditBill.table.holder"
                            titleTextType="I18N"
                            valueText={`${billItem.cuitTenedor} ${billItem.razonSocialTenedor}`}
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>
                </>
            )}
            {isToPay && (
                <>
                    <GridTable.Data
                        className={isDesktop && "debtor-class"}
                        columnStart={2}
                        rowStart={1}
                        rowWidth={1}
                        alignX={isDesktop ? "center" : "flex-start"}>
                        <CustomData
                            titleText="creditBill.table.holder"
                            titleTextType="I18N"
                            valueText={`${billItem.cuitTenedor} ${billItem.razonSocialTenedor}`}
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 2}
                        rowStart={isDesktop ? 1 : 2}
                        rowWidth={1}
                        alignX={isDesktop ? "center" : "flex-start"}>
                        <CustomData
                            titleText="creditBill.table.emitter"
                            titleTextType="I18N"
                            valueText={`${billItem.facturaId.cuitEmisor} ${billItem.razonSocialEmisor}`}
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>
                </>
            )}
            {isInTenure && (
                <>
                    <GridTable.Data
                        className={isDesktop && "debtor-class"}
                        columnStart={2}
                        rowStart={1}
                        rowWidth={1}
                        alignX={isDesktop ? "center" : "flex-start"}>
                        <CustomData
                            titleText="creditBill.table.emitter"
                            titleTextType="I18N"
                            valueText={`${billItem.facturaId.cuitEmisor} ${billItem.razonSocialEmisor}`}
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 2}
                        rowStart={isDesktop ? 1 : 2}
                        rowWidth={1}
                        alignX={isDesktop ? "center" : "flex-start"}>
                        <CustomData
                            titleText="creditBill.table.debtor"
                            titleTextType="I18N"
                            valueText={`${billItem.cuitComprador} ${billItem.razonSocialComprador}`}
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>
                </>
            )}

            <GridTable.Data
                columnStart={isDesktop ? 4 : 2}
                rowStart={isDesktop ? 1 : 3}
                rowWidth={1}
                className={isDesktop && "spacing-class"}>
                <CustomData
                    titleText="creditBill.table.emission"
                    titleTextType="I18N"
                    valueText={billItem.fechaEmision}
                    valueTextType="DATE"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 5 : 2} rowStart={isDesktop ? 1 : 4} rowWidth={1}>
                <CustomData
                    titleText="creditBill.table.expiration"
                    titleTextType="I18N"
                    valueText={<FormattedDate date={billItem.fechaVencimientoPago} />}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 6 : 2} rowStart={isDesktop ? 1 : 5} rowWidth={1}>
                <CustomData
                    titleText="creditBill.table.amount"
                    titleTextType="I18N"
                    valueText={
                        <FormattedAmount
                            currency={monedas[billItem.moneda]}
                            quantity={billItem.saldoAceptado}
                            className={isDesktop && "credit-bills__amount"}
                        />
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 7 : 3}
                rowStart={1}
                rowWidth={1}
                flexDirection="column"
                className={isDesktop ? "credit-bills__tag-status spacing-class" : "credit-bills__tag-status"}>
                {billItem.estadoFactura.split("-").map((item) => (
                    <InfoTag type="info" message={`${item}`} tagBackground={statusTagColor(billItem.estadoFactura)} />
                ))}
            </GridTable.Data>
            <GridTable.Data
                className="tags-wrapper icon-cbu-class"
                columnStart={isDesktop ? 8 : 2}
                rowStart={isDesktop ? 1 : 6}
                rowWidth={1}>
                {!isDesktop && <I18n component="span" id="creditBill.table.registeredCbu" />}
                {billItem.cbuValidada === "s" ? (
                    <Image src="images/figma/icon/success.svg" className="svg-icon svg-caret checkbox icon-large" />
                ) : (
                    <Image src="images/figma/icon/error.svg" className="svg-icon icon-large" />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 9 : 4} rowStart={isDesktop ? 1 : 1} rowWidth={1}>
                {billActionOptions.length > 0 && !isExpired && (
                    <CustomButton
                        pullRight
                        className="view-options"
                        icon="images/figma/icon/menu-mobile.svg"
                        options={billActionOptions}
                    />
                )}
            </GridTable.Data>
        </>
    );
});

CreditBillItem.propTypes = {
    billItem: shape({}).isRequired,
    onSelectRow: func.isRequired,
    selectedBills: instanceOf(Array).isRequired,
    tabOption: string.isRequired,
    isDesktop: bool.isRequired,
};

export default CreditBillItem;
